"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessTypes = void 0;
var AccessTypes;
(function (AccessTypes) {
    AccessTypes["MILLENNIUM"] = "10";
    AccessTypes["PING"] = "15";
    AccessTypes["AMWELL"] = "20";
    AccessTypes["IDDATAWEB"] = "25";
    AccessTypes["R1"] = "30";
    AccessTypes["CHANGE_HEALTHCARE"] = "35";
    AccessTypes["CDR"] = "38";
    AccessTypes["SELECTHEALTH"] = "160";
})(AccessTypes || (exports.AccessTypes = AccessTypes = {}));
//# sourceMappingURL=access-types.enum.js.map